import {Col, Row} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import { Config } from 'shared/config';

import {HeroSectionCarousel} from 'shared/pages/LandingPage/HeroSection/HeroSectionCarousel';
import {HeroSectionLoginForm} from 'shared/pages/LandingPage/HeroSection/HeroSectionLoginForm';

import './styles.scss';

export const HeroSection = () => {
    const navigate = useNavigate();

    // TODO: fix this
    // currently the Primary school version
    const signupPageId: number = Config.isProduction ? 5072183076323328 : 5944569048858624;

    console.log('Config.isProduction', Config.isProduction);

    return (
        <Row className="HeroSection bg-primary no-gutters align-items-stretch">
            <Col xs={12} sm={12} md={12} lg={6} className="HeroSection--content">
                <HeroSectionCarousel />
            </Col>
            <Col xs={12} sm={12} md={12} lg={5} className="LoginForm">
                <div>
                    <div className="Heading">
                        <p><Trans>A launchpad for aspiring Entrepreneurs</Trans></p>
                    </div>
                    <div className="CallToAction">
                        <p>
                            Signup now to recieve the first two modules of 
                            <span className="CallToAction--italics"> Future Founders: Kickstater Course </span> 
                            for FREE!
                        </p>
                    </div>
                </div>
                <div className="SignupSection--container">
                    <h2 className="mt-auto pb-1"><Trans>Start your journey here...</Trans></h2>
                    <button className="SignupSection--button" onClick={() => navigate(`/join/public/${signupPageId}`)}><Trans>Signup for free</Trans></button>
                </div>
                <div className="divider">
                    <span><Trans>OR</Trans></span>
                </div>
                <div className="LogIn">
                        <p><Trans>Log In</Trans></p>
                    </div>
                <div className="LoginForm--container">
                    <HeroSectionLoginForm />
                </div>
            </Col>
        </Row>
    );
};